<template lang="pug">
div
  .columns
    //Collection names
    .column
      MyCollectionPanel

    //papers in a collection
    .column.is-three-quarters
      .panel.is-primary
        p.panel-heading Papers
        .panel-block
          PapersTable
</template>
<script>
import { mapMutations, mapState } from "vuex";
import PapersTable from "./PapersTable";
import MyCollectionPanel from "./MyCollectionPanel";
export default {
  components: {
    PapersTable,
    MyCollectionPanel
  },
  computed: {
    ...mapState("collection", {
      selectedCollectionId: (s) => s.selectedCollectionId,
    }),
  },
  methods: {
    ...mapMutations("createCollection", {
      openCreateCollectionModal: "openModal",
    }),
    ...mapMutations("shareCollection", {
      openShareCollectionModal: "openModal",
    }),
  },
};
</script>